import MiniCart from '../components/mini-cart.js'

export default {
  scrollingDown: false,
  lastKnownWindowScrollY: 0,
  // JavaScript to be fired on all pages
  init() {
    MiniCart.init()

    var ZD = ZD || {};

    ZD.youtube = {

      onDOMContentLoaded: function() {
        var youtube = document.querySelectorAll( '.youtube' );

      for (var i = 0; i < youtube.length; i++) {
      var source = 'https://img.youtube.com/vi/'+ youtube[i].dataset.embed +'/sddefault.jpg';
      var image = new Image();
          image.src = source;
          image.addEventListener( 'load', function() {
                youtube[ i ].appendChild( image );
          }( i ) );

          youtube[i].addEventListener( 'click', function() {
            var iframe = document.createElement( 'iframe' );

                iframe.setAttribute( 'frameborder', '0' );
                iframe.setAttribute( 'allowfullscreen', '' );
                iframe.setAttribute( 'src', 'https://www.youtube.com/embed/'+ this.dataset.embed +'?rel=0&autoplay=1&showinfo=0&autohide=1&modestbranding=1' );

                this.innerHTML = '';
                this.appendChild( iframe );
          } );
      }
      },

    };

    // ZD.vimeo = {

    //   onDOMContentLoaded: function() {
    //     var vimeo = document.querySelectorAll( '.vimeo' );

    //   for (var i = 0; i < vimeo.length; i++) {
    //   var source = 'http://vimeo.com/api/v2/video/'+ vimeo[i].dataset.embed +'.json?callback=showThumb';
    //   var image = new Image();
    //       image.src = source;
    //       image.addEventListener( 'load', function() {
    //             vimeo[ i ].appendChild( image );
    //       }( i ) );

    //       vimeo[i].addEventListener( 'click', function() {
    //         var iframe = document.createElement( 'iframe' );

    //             iframe.setAttribute( 'frameborder', '0' );
    //             iframe.setAttribute( 'allowfullscreen', '' );
    //             iframe.setAttribute( 'width', '605');
    //             iframe.setAttribute( 'height', '340' )
    //             iframe.setAttribute( 'src', 'https://player.vimeo.com/video/'+ this.dataset.embed +'?title=0&byline=0' );

    //             this.innerHTML = '';
    //             this.appendChild( iframe );
    //       } );
    //   }
    //   },

    // };

    ZD.selfhosted = {

      onDOMContentLoaded: function() {
      var selfhosted = document.querySelectorAll( '.selfhosted' );

      for (var i = 0; i < selfhosted.length; i++) {
        var source = $(selfhosted[i]).data('thumb');
        var image = new Image();
            image.src = source;
            // image.setAttribute( 'data-src' , image.src);
            // image.addEventListener( 'load', function() {
            //       selfhosted[ i ].appendChild( image );
            // }( i ) );

            // selfhosted[i].addEventListener( 'click', function() {
            //   var video = document.createElement( 'video' );
            //       video.setAttribute( 'width' , '720');
            //       video.setAttribute( 'height' , '405');
            //       video.setAttribute( 'controls', 'controls');
            //   var sourceMP4 = document.createElement('source');
            //       sourceMP4.setAttribute( 'type' , 'video/mp4');
            //       sourceMP4.setAttribute( 'src' , $(this).data('video'));

            //   video.appendChild(sourceMP4);
            //   this.innerHTML = '';
            //   this.appendChild( video );
            // } );
      }
      },
    }

    // Initialise ZD.youtube when DOM is ready
    if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading'){
      ZD.youtube.onDOMContentLoaded();
      // ZD.vimeo.onDOMContentLoaded();
      ZD.selfhosted.onDOMContentLoaded();
    } else {
      document.addEventListener('DOMContentLoaded', ZD.youtube.onDOMContentLoaded);
      // document.addEventListener('DOMContentLoaded', ZD.vimeo.onDOMContentLoaded);
      document.addEventListener('DOMContentLoaded', ZD.selfhosted.onDOMContentLoaded);
    }

    // Init body classes based on window scroll
    document.querySelectorAll('body')[0].classList.add('is-scrolled-top');
    window.addEventListener('scroll', this.setBodyScrollClass);

    // Init banner (header with primary navigation and search form)
    this.initBanner(document.querySelectorAll('.banner')[0]);
  },
  initBanner($banner) {
    if (!$banner) {
      console.warn('Could not init banner. No root element was found.')
      return false;
    }

    var $menu = $banner.querySelectorAll('.banner__menu')[0];
    var $menuToggle = $banner.querySelectorAll('[data-toggle="primary-navigation"]')[0];
    var $burgernav = $banner.querySelectorAll('.svg-burger')[0];
    var $subnav = $banner.querySelectorAll('.banner__subnav')[0];
    var $subnavToggle = $banner.querySelectorAll('[data-toggle="sub-navigation"]')[0];
    var $searchForm = $banner.querySelectorAll('.banner__search')[0];
    var $searchToggle = $banner.querySelectorAll('[data-toggle="search"]')[0];
    var dropdowns = $banner.querySelectorAll('.sub-menu, .banner__search');

    // Init menu toggle button
    if ($menuToggle) {
      $menuToggle.addEventListener('click', function () {
        $burgernav.classList.toggle('is-open');
        $menu.classList.toggle('is-open');
        if ($subnav) $subnav.classList.remove('is-open');
        $searchForm.classList.remove('is-open');
      });
    }

    // Init subnav toggle button
    if ($subnavToggle) {
      $subnavToggle.addEventListener('click', function () {
        if ($subnav) $subnav.classList.toggle('is-open');
        $menu.classList.remove('is-open');
        $searchForm.classList.remove('is-open');
      });
    }
    // TODO: Move the if's to the global repo
    // Init search toggle button
    if ($searchToggle) {
      $searchToggle.addEventListener('click', function () {
        if (window.innerWidth < 992) {
          $searchForm.classList.toggle('is-open');
          $menu.classList.remove('is-open');
          if ($subnav) $subnav.classList.remove('is-open');
        } else {
          $($searchForm).submit();
        }
      });
    }

    // Loop dropdowns
    Array.prototype.forEach.call(dropdowns, function ($dropdown) {

      // Locate the trigger element for toggling dropdown
      // First search for an element with [data-toggle] matching the dropdown ID
      // Otherwise fallback to the first sibling link element
      var $trigger = document.querySelectorAll('[data-toggle="' + $dropdown.id + '"]')[0];
      $trigger = ($trigger) ? $trigger : $dropdown.parentNode.getElementsByTagName('a')[0];
      if ($trigger) {

        $trigger.addEventListener('mouseenter', function () {

          // Only react to event if $menu is not mobile/collapsed
          if (window.getComputedStyle($menu).getPropertyValue('position') !== 'absolute') {
            $trigger.isMouseOver = true;
            $dropdown.classList.add('is-open');
          }
        });
        $trigger.addEventListener('mouseleave', function () {

          // Only react to event if $menu is not mobile/collapsed
          if (window.getComputedStyle($menu).getPropertyValue('position') !== 'absolute') {
            $trigger.isMouseOver = false;

            // Give users extra time to mouseover the dropdown before closing
            setTimeout(function () {

              // Only close if not hovering over dropdown
              if (!$dropdown.isMouseOver) {
                $dropdown.classList.remove('is-open');
              }
            }, 100);
          }
        });

        // Lock open state on dropdown enter/leave
        $dropdown.addEventListener('mouseenter', function () {

          // Only react to event if $menu is not mobile/collapsed
          if (window.getComputedStyle($menu).getPropertyValue('position') !== 'absolute') {
            $dropdown.isMouseOver = true;
          }
        });
        $dropdown.addEventListener('mouseleave', function () {

          // Only react to event if $menu is not mobile/collapsed
          if (window.getComputedStyle($menu).getPropertyValue('position') !== 'absolute') {
            $dropdown.isMouseOver = false;

            // Delay close
            setTimeout(function () {
              // Only close if not hovering over trigger
              if (!$trigger.isMouseOver) {
                $dropdown.classList.remove('is-open');
              }
            }, 100);
          }
        });
      }
    });
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },

  // Function for setting scroll class on body
  setBodyScrollClass() {
    var $body = document.querySelectorAll('body')[0];

    // At page top
    if (window.scrollY === 0) {
      $body.classList.add('is-scrolled-top');
      $body.classList.remove('is-scrolled-down');
      $body.classList.remove('is-scrolled-up');
      this.scrollingDown = false;
    }

    // At page bottom
    else if (document.documentElement.offsetHeight - document.documentElement.scrollTop - window.innerHeight === 0) {
      $body.classList.add('is-scrolled-bottom');
      $body.classList.remove('is-scrolled-down');
      this.scrollingDown = true;
    }

    // Scrolling up
    else if (this.lastKnownWindowScrollY > window.scrollY) {
      if (this.scrollingDown) {
        $body.classList.add('is-scrolled-up');
        $body.classList.remove('is-scrolled-bottom');
        $body.classList.remove('is-scrolled-down');
        this.scrollingDown = false;
      }
    }

    // Scrolling down
    else if (this.lastKnownWindowScrollY < window.scrollY) {
      if (!this.scrollingDown) {
        $body.classList.add('is-scrolled-down');
        $body.classList.remove('is-scrolled-top');
        $body.classList.remove('is-scrolled-up');
        this.scrollingDown = true;
      }
    }

    // This never happens, because all scenarios are covered above
    // else {}

    // Store current scrollY for next tick
    this.lastKnownWindowScrollY = window.scrollY;
  },
};
